import React from 'react';
import PropTypes from 'prop-types';
import { LogoIcon } from '../../../assets/icons';
import './styles.scss';
import { RAYCHAT_WEBSITE_URL } from '../../../utils/constants';

const AuthTopNavbar = ({ children }) => {
  return (
    <header className='navbar'>
      <div className='container flex'>
        <nav className='flex'>
          <ul>
            <li> {children}</li>
          </ul>
        </nav>
        <div className='logo'>
          <a href={RAYCHAT_WEBSITE_URL}>
            <img src={LogoIcon} alt='' />
          </a>
        </div>
      </div>
    </header>
  );
};

AuthTopNavbar.propTypes = {
  children: PropTypes.element,
};

export default AuthTopNavbar;
